var BreakPointsEnum = /* @__PURE__ */ ((BreakPointsEnum2) => {
  BreakPointsEnum2["xxs"] = "(min-width: 0px)";
  BreakPointsEnum2["xxsMax"] = "(max-width: 479px)";
  BreakPointsEnum2["xs"] = "(min-width: 480px)";
  BreakPointsEnum2["xsMax"] = "(max-width: 575px)";
  BreakPointsEnum2["sm"] = "(min-width: 576px)";
  BreakPointsEnum2["smMax"] = "(max-width: 767px)";
  BreakPointsEnum2["md"] = "(min-width: 768px)";
  BreakPointsEnum2["mdMax"] = "(max-width: 991px)";
  BreakPointsEnum2["lg"] = "(min-width: 992px)";
  BreakPointsEnum2["lgMax"] = "(max-width: 1199px)";
  BreakPointsEnum2["xl"] = "(min-width: 1200px)";
  BreakPointsEnum2["xlMax"] = "(max-width: 1439px)";
  BreakPointsEnum2["xxl"] = "(min-width: 1440px)";
  BreakPointsEnum2["xxlMax"] = "(max-width: 1599px)";
  BreakPointsEnum2["xxxl"] = "(min-width: 1600px)";
  return BreakPointsEnum2;
})(BreakPointsEnum || {});
export {
  BreakPointsEnum
};
